import { useState, useEffect } from 'react'
import { connect, Field } from 'formik'
import Autosuggest from 'react-autosuggest'
import CountryList from 'i18n-iso-countries'
import {JSONFetcher, FormGroup} from 'shared'

CountryList.registerLocale(require('i18n-iso-countries/langs/de.json'))
CountryList.registerLocale(require('i18n-iso-countries/langs/en.json'))

export const AddressFields = connect(({formik, required}) => {
  const countries = CountryList.getNames(I18n.locale)
  const countryOptions = Object.keys(countries).map(
    alpha2 => <option value={alpha2} key={alpha2}>{countries[alpha2]}</option>
  )
  const numericZip = [
    'RU', 'DE', 'TR', 'FR', 'IT', 'ES', 'PL', 'RO', 'BE', 'GR', 'CZ', 'PT', 'HU', 'CH', 'BG',
    'RS', 'DK', 'FI', 'SK', 'NO'
  ].includes(formik.values.country_alpha2)
  const buildLabel = name => `${I18n.t(`donate.attributes.${name}`)}${required ? '*' : ''}`

  useEffect(() => {
    if (formik.values.country_alpha2 === 'DE' && formik.values.city === '' && formik.values.zip.length === 5) {
      JSONFetcher.load({
        url: `/de/zip_cities/${formik.values.zip}.json`,
        success: r => { if (r.city) formik.setFieldValue('city', r.city) }
      })
    }
  }, [formik.values.zip])

  return <div className='flex flex-wrap'>
    <div className='form-group desktop:w-1/3 inline-block'>
      <label className='control-label sr-only' htmlFor='country_alpha2'>{buildLabel('country')}</label>
      <Field component='select' className='form-control' aria-required='true' name='country_alpha2' id='country_alpha2'>
        {countryOptions}
      </Field>
    </div>

    <Field
      name='zip'
      placeholder={buildLabel('zip')}
      label={buildLabel('zip')}
      component={FormGroup}
      groupClass='w-1/3 desktop:w-1/4 desktop:pl-2 pr-2 inline-block'
      labelClass='sr-only'
      type='text'
      pattern={numericZip ? '[0-9]*' : null}
      inputMode={numericZip ? 'tel' : 'text'}
    />

    <Field
      name='city'
      labelClass='sr-only'
      groupClass='w-2/3 desktop:w-5/12 inline-block'
      placeholder={buildLabel('city')}
      label={buildLabel('city')}
      component={FormGroup}
    />

    <Field
      placeholder={buildLabel('street')}
      label={buildLabel('street')}
      name='street'
      component={StreetAutosuggest}
      labelClass='sr-only'
      groupClass='w-full'
    />
  </div>
})

const StreetAutosuggest = connect((props) => {
  const [suggestions, setSuggestions] = useState([])
  const {field, formik, placeholder} = props

  const fetchSuggestions = ({value}) => {
    if (formik.values.country_alpha2 !== 'DE' || value.length < 1 || formik.values.zip.length !== 5) return

    JSONFetcher.load({
      url: `/de/zip_streets.json?zip=${formik.values.zip}&street=${value}`,
      success: response => {
        if (!response.streets) return
        setSuggestions(response.streets)
      }
    })
  }

  const handleSuggestionSelected = (event, suggestion) => {
    if (suggestion.method === 'enter') event.preventDefault()
    props.formik.handleChange(event)
    props.formik.setFieldValue('street', suggestion.suggestion + ' ')
  }

  return <FormGroup {...props}>
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={fetchSuggestions}
      onSuggestionsClearRequested={() => setSuggestions([])}
      onSuggestionSelected={handleSuggestionSelected}
      getSuggestionValue={suggestion => suggestion}
      renderSuggestion={suggestion => suggestion}
      inputProps={{...field, placeholder}}
    />
  </FormGroup>
})
